<template>
  <v-container style="overflow: auto; min-height: 700px; max-height: 700px;">

    <!-- -------------แผนที่แสดงบ้านของผู้รับบริการและแหล่งประโยชน์ในชุมชน------------- -->

    <v-form ref="form1">
      <v-row class="pt-10" justify="center">
        <v-col cols="auto">
          <span class="text-333333 w-700 font-18">แผนที่แสดงบ้านของผู้รับบริการและแหล่งประโยชน์ในชุมชน</span>
        </v-col>
      </v-row>
      <v-row class="pb-0 pt-2">
        <v-col cols="12" lg="4" md="4" sm="4" class="pt-0">
          <v-row>
            <v-col cols="12"></v-col>
            <v-col class="pt-4">
              <v-btn depressed color="#F7F8FA" @click="checkGPS()" block style="white-space: normal;display: inline;"
                :readonly="status == 'see'">
                <v-icon size="20" class="pr-1" color="#00A99D">mdi-crosshairs-gps</v-icon><span
                  class="text-7E8386 w-400 font-14">คลิกเพื่อหาที่อยู่ปัจจุบันของคุณ</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" lg="4" md="4" sm="4" class="py-0">
          <span class="font-16 w-500 text-333333">ละติจูด <span class="red--text">*</span></span>
          <v-text-field v-model="map_detail.lat" placeholder="ละติจูด" solo dense @input="getGPS()" hide-details="auto"
            required class="pt-1" :rules="status == 'see' ? [] : rules_detail_number"
            :readonly="status == 'see'"></v-text-field>
        </v-col>
        <v-col cols="12" lg="4" md="4" sm="4" class="py-0">
          <span class="font-16 w-500 text-333333">ลองติจูด <span class="red--text">*</span></span>
          <v-text-field v-model="map_detail.lng" placeholder="ลองติจูด" solo dense @input="getGPS()" hide-details="auto"
            required class="pt-1" :rules="status == 'see' ? [] : rules_detail_number"
            :readonly="status == 'see'"></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-text-field solo dense placeholder="ค้นหาตำแหน่งที่อยู่" v-model="location_address" hide-details="auto"
            @keypress.enter="getLocation(location_address)" color="#00A99D"
            hint="กรอกคำค้นหา กด Enter หรือ กดปุ่มค้นหา เพื่อค้นหาที่อยู่ของท่าน" :readonly="status == 'see'">
            <template slot="append">
              <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn v-bind="attrs" v-on="on" icon color="#00A99D" @click="getLocation(location_address)">
                    <v-icon medium dark>mdi-magnify</v-icon>
                  </v-btn>
                </template>
                <span>ค้นหา</span>
              </v-tooltip>
            </template>
          </v-text-field>
        </v-col>
      </v-row>
      <v-row ref="printcontent">
        <v-col cols="12" class="pt-0 pb-4" v-if="status !== 'see'">
          <StadiaMap id="capture" ref="locateUser" :items="map_detail" @place-name="changeLocation"
            @map-clicked="changeLocation" />
        </v-col>
        <v-col cols="12" class="pt-0 pb-4" v-else>
          <StadiaMap id="capture" ref="locateUser" :items="map_detail" :draggable="false" @place-name="changeLocation"
            @map-clicked="changeLocation" />
        </v-col>
        <!-- <v-col cols="12" class="pt-0 pb-4" v-if="status !== 'see'">
          <GmapMap
            id="capture"
            :center="{ lat: latitude, lng: longitude }"
            :zoom="15"
            class="map"
            :options="{
              zoomControl: true,
              mapTypeControl: false,
              scaleControl: false,
              streetViewControl: false,
              rotateControl: true,
              fullscreenControl: true,
              disableDefaultUi: true,
            }"
          >
            <GmapMarker
              @click="changeLocation"
              @dragend="changeLocation"
              :draggable="true"
              :position="{
                lat: lat,
                lng: lng,
              }"
            />
          </GmapMap>
        </v-col>
        <v-col cols="12" class="pt-0 pb-4" v-else>
          <GmapMap
            id="capture"
            :center="{ lat: latitude, lng: longitude }"
            :zoom="15"
            class="map"
            :options="{
              zoomControl: false,
              mapTypeControl: false,
              scaleControl: false,
              streetViewControl: false,
              rotateControl: false,
              fullscreenControl: true,
              disableDefaultUi: false,
            }"
          >
            <GmapMarker
              @click="changeLocation"
              @dragend="changeLocation"
              :draggable="false"
              :position="{
                lat: lat,
                lng: lng,
              }"
            />
          </GmapMap>
        </v-col> -->
      </v-row>
      <v-row class="pt-0 pb-10 px-3">
        <span class="font-16 w-600 text-333333 pr-5 pt-2">อยู่ในพื้นที่รับผิดชอบของหน่วยบริการหลัก คือ <span
            class="red--text">*</span></span>
        <v-text-field v-model="map_detail.area_of_responsibility" solo dense hide-details="auto"
          placeholder="กรุณาระบุพื้นที่รับผิดชอบของหน่วยบริการหลัก" :rules="status == 'see' ? [] : rules_detail"
          :readonly="status == 'see'">
        </v-text-field>
      </v-row>
      <!-- <v-row class="pt-0">
        <v-col cols="12" lg="12" md="12" sm="12" class="pt-0 pr-0" align-self="center" >
          <span class="font-16 w-600 text-333333" style="text-decoration: underline">สัญลักษณ์</span>
        </v-col>
        <v-col cols="12" lg="12" md="12" sm="12" class="px-6">
          <v-row style="border: 1px solid #000000;">
            <v-col v-for="map_detail in symbol_list" :key="map_detail.id" cols="12" mg="6" sm="6" lg="4" xl="4" class="pa-0">
              <v-card outlined tile style="border: 1px solid #000000;">
                <v-card-text>
                  <v-row class="pl-3 pr-8" style="height: 80px;">
                    <v-col cols="8" xl="6" lg="6" md="6" sm="6" align-self="start">
                      <span class="font-16 text-333333">{{ map_detail.symbol }}</span>
                    </v-col>
                    <v-col cols="4" xl="6" lg="6" md="6" sm="6" class="pr-0" style="text-align: -webkit-right;" align-self="center">
                      <v-img :src="map_detail.img" contain max-width="45"/>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row> -->

      <!-- -------------------------ประวัติครอบครัว-------------------------- -->

      <v-row class="pt-10" justify="center">
        <v-col cols="12" class="pr-0 pt-2">
          <v-row no-gutters style="justify-content: center;">
            <span
              :class="display_vuetify !== 'xs' ? 'pt-2 w-700 font-18 text-333333' : 'w-700 font-18 text-333333'">การประเมินสภาพครอบครัว/ประวัติครอบครัว
              จำนวนสมาชิกในบ้าน</span>
            <v-text-field v-model="family_detail.family_member" placeholder="จำนวน" solo dense hide-details="auto"
              class="px-3" required type="number" min='1' style="max-width: 100px !important;"
              @change="checkMember(family_detail.family_member)" :readonly="status == 'see'"
              @keypress="validateNumber"></v-text-field>
            <span
              :class="display_vuetify !== 'xs' ? 'pt-2 w-700 font-18 text-333333' : 'w-700 font-18 text-333333'">คน</span>
          </v-row>
        </v-col>
      </v-row>
      <v-row class="pb-6 pt-2">
        <v-col cols="12" class="py-0 d-flex">
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" @click="aad_family()" icon :readonly="status == 'see'">
                <v-icon color="#00A99D">mdi-plus-box</v-icon>
              </v-btn>
            </template>
            <span>เพิ่มข้อมูลสมาชิก</span>
          </v-tooltip>
        </v-col>
      </v-row>
      <div class="px-3 pt-3 pb-10" style="min-height: 25vh; max-height: 555px;overflow-x: hidden;overflow-y: auto;">
        <v-row class="pt-0 pb-5 mx-0" v-for="(map_detail, index) in family_detail.family_list" :key="index">
          <v-col cols="9" sm="11" md="11" lg="11"
            style="border: 1px solid #00A99D; border-radius: 10px; padding: 15px 0px;"
            :id="family_detail.family_list.length - index == 1 ? 'content' : index">
            <v-row class="px-5 mt-0 pb-0">
              <v-col cols="12" class="pt-0">
                <span class="text-333333 w-600 font-16">สมาชิกคนที่ : {{ index + 1 }}</span>
              </v-col>
            </v-row>
            <v-row class="px-5">
              <v-col cols="12" sm="6" md="6" lg="4" class="pr-0 d-flex d-flex-row">
                <span class="font-16 text-333333 pr-3 pt-2">ชื่อ <span class="red--text">*</span></span>
                <v-text-field solo dense hide-details="auto" placeholder="กรอกชื่อ"
                  v-model="family_detail.family_list[index].name" :rules="status == 'see' ? [] : rules_detail"
                  :readonly="status == 'see'"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" lg="3" class="pr-0 d-flex d-flex-row">
                <span class="font-16 text-333333 pt-2">อายุ <span class="red--text">*</span></span>
                <v-text-field solo dense hide-details="auto" placeholder="กรอกอายุ" class="px-3"
                  v-model="family_detail.family_list[index].age" :rules="status == 'see' ? [] : rules_detail_number"
                  :readonly="status == 'see'"></v-text-field>
                <span class="font-16 text-333333 pt-2">ปี</span>
              </v-col>
              <v-col cols="12" sm="6" md="6" lg="5" class="pr-0 d-flex d-flex-row">
                <span class="font-16 text-333333 pr-3 pt-2">อาชีพ <span class="red--text">*</span></span>
                <v-text-field solo dense hide-details="auto" placeholder="กรอกอาชีพ"
                  v-model="family_detail.family_list[index].occupation" :rules="status == 'see' ? [] : rules_detail"
                  :readonly="status == 'see'"></v-text-field>
              </v-col>
              <v-col cols="4" sm="6" md="6" lg="4" class="d-flex d-flex-row">
                <span class="font-16 text-333333 pr-3 pt-2">สิทธิการรักษา <span class="red--text">*</span></span>
                <v-text-field solo dense hide-details="auto" placeholder="กรอกสิทธิการรักษา"
                  v-model="family_detail.family_list[index].right_of_treatment"
                  :rules="status == 'see' ? [] : rules_detail" :readonly="status == 'see'"></v-text-field>
              </v-col>
              <v-col cols="8" sm="12" md="12" lg="8" class="pt-0 d-flex d-flex-row">
                <span class="font-16 text-333333 pr-3 pt-2">ลักษณะที่ประเมิน/ตรวจพบ <span
                    class="red--text">*</span></span>
                <v-text-field solo dense hide-details="auto" placeholder="กรอกลักษณะที่ประเมิน/ตรวจพบ"
                  v-model="family_detail.family_list[index].detected_characteristics"
                  :rules="status == 'see' ? [] : rules_detail" :readonly="status == 'see'"></v-text-field>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="auto" align-self="center" class="px-0 pt-0">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" @click="delete_family(index)" icon :readonly="status == 'see'">
                  <v-icon color="#F5222D">mdi-minus-box</v-icon>
                </v-btn>
              </template>
              <span>ลบ จุดตรวจ</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </div>

      <!-- --------------------ผังเครือญาติ----------------------- -->
      <v-row class="pt-10" justify="center">
        <v-col cols="auto">
          <span class="w-700 font-18 text-333333">ผังเครือญาติ</span>
        </v-col>
      </v-row>
      <v-row class="pb-10 pt-2 px-4 d-flex d-flex-row">
        <v-col cols="12" sm="4" md="3" lg="3" xl="2" class="py-0">
          <img max-width="100%" max-height="500px" src="@/assets/image/Group.png" />
        </v-col>
        <v-col cols="12" sm="8" md="9" lg="9" xl="10" align="center" class="py-0">
          <v-card outlined :style="!isWrite ? 'border: 1px solid #333333;' : 'border: 2px solid #00A99D;'"
            min-height="500">
            <v-card-title>
              <v-row>
                <v-spacer></v-spacer>
                <v-tooltip v-if="family_detail.family_image !== '' && edit == false" bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" class="mr-2" fab small text depressed @click="edit = true">
                      <v-icon size="30" color="#00A99D">mdi-pen</v-icon>
                    </v-btn>
                  </template>
                  <span>แก้ไข</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" class="mr-2" fab small text depressed
                      :disabled="!isWrite || (family_detail.family_image !== '' && edit == false)" @click="clearBack()">
                      <v-icon size="30"
                        :color="!isWrite || (family_detail.family_image !== '' && edit == false) ? '#333333' : '#00A99D'">mdi-replay</v-icon>
                    </v-btn>
                  </template>
                  <span>ย้อนกลับ</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" fab small text depressed
                      :disabled="!isWrite || (family_detail.family_image !== '' && edit == false)" @click="clearSign()">
                      <v-icon size="30"
                        :color="!isWrite || (family_detail.family_image !== '' && edit == false) ? '#333333' : '#EB5757'">mdi-cancel</v-icon>
                    </v-btn>
                  </template>
                  <span>ล้างค่า</span>
                </v-tooltip>
              </v-row>
            </v-card-title>

            <v-card-text v-if="family_detail.family_image !== '' && edit == false">
              <v-img :src="family_detail.family_image" />
            </v-card-text>
            <v-card-text v-else-if="status == 'see'">
              <v-img width="100%" height="500px" :src="family_detail.family_image" />
            </v-card-text>
            <v-card-text v-else>
              <VueSignaturePad width="100%" height="500px" ref="signaturePad" :options="{
                onBegin: () => {
                  $refs.signaturePad.resizeCanvas();
                },
                onEnd,
              }" />
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- ----------------Family Problem & Other Problem---------------- -->
      <v-row class="pt-10" justify="center">
        <v-col cols="auto">
          <span class="w-700 font-18 text-333333">Family Problem & Other Problem</span>
        </v-col>
      </v-row>
      <v-row class="pb-0 pt-2 pl-6">
        <v-col cols="12" class="py-0">
          <span class="w-700 font-16 text-333333">ปัญหาในครอบครัวและมุมมองต่อผู้รับบริการ <span
              class="red--text">*</span></span>
        </v-col>
      </v-row>
      <v-row class="pl-16 pr-3">
        <v-checkbox hide-details="auto" dense class="mr-12"
          v-model="family_detail.family_problem.family_problems_and_perspectives_on_servants.status" color="#00A99D"
          value="1" @click="family_detail.family_problem.family_problems_and_perspectives_on_servants.title = 'ไม่มี'"
          :rules="status == 'see' ? [] : rules_checkbox" :readonly="status == 'see'">
          <template v-slot:label>
            <span class="text-333333 w-500 font-16">ไม่มี</span>
          </template>
        </v-checkbox>
        <v-checkbox hide-details="auto" dense class="pr-5"
          v-model="family_detail.family_problem.family_problems_and_perspectives_on_servants.status" color="#00A99D"
          value="2" @click="family_detail.family_problem.family_problems_and_perspectives_on_servants.title = 'มี'"
          :rules="status == 'see' ? [] : rules_checkbox" :readonly="status == 'see'">
          <template v-slot:label>
            <span class="text-333333 w-500 font-16">มี</span>
          </template>
        </v-checkbox>
        <v-row no-gutters
          v-if="family_detail.family_problem.family_problems_and_perspectives_on_servants.status == '2'">
          <span class="pr-3 w-500 font-16 text-333333 pt-2">ระบุ</span>
          <v-text-field dense solo hide-details="auto" placeholder="กรุณาระบุปัญหาในครอบครัว" color="#00A99D"
            v-model="family_detail.family_problem.family_problems_and_perspectives_on_servants.detail"
            :rules="status == 'see' ? [] : rules_detail" :readonly="status == 'see'"></v-text-field>
        </v-row>
      </v-row>
      <v-row class="pb-0 pt-2 pl-6">
        <v-col cols="12" class="py-0">
          <span class="w-700 font-16 text-333333">การรับรู้ของผู้รับบริการต่อปัญหาในครอบครัว</span>
        </v-col>
      </v-row>
      <v-row class="pb-0 pt-2 pl-16 pr-3">
        <span class="pr-3 font-16 text-333333 pt-2">การรับรู้ มุมมอง ต่อปัญหาและความช่วยเหลือ</span>
        <v-text-field dense solo hide-details="auto" placeholder="กรุณาระบุการรับรู้ มุมมอง ต่อปัญหาและความช่วยเหลือ"
          color="#00A99D" v-model="family_detail.family_problem.servant_perception_of_Family_problems.detail"
          :rules="status == 'see' ? [] : rules_space_bar" :readonly="status == 'see'" ></v-text-field>
      </v-row>
      <v-row class="pb-0 pt-2 pl-6">
        <v-col cols="12" class="py-0">
          <span class="w-700 font-16 text-333333">ความต้องการช่วยเหลือของผู้ป่วย</span>
        </v-col>
      </v-row>
      <v-row class="pb-0 pt-2 pl-16 pr-3">
        <v-checkbox hide-details="auto" dense
          v-model="family_detail.family_problem.patient_need_for_help.knowledge_of_disease_counseling.status"
          color="#00A99D" value="1"
          @click="family_detail.family_problem.patient_need_for_help.knowledge_of_disease_counseling.title = 'ความรู้คำปรึกษา เรื่องโรค การใช้ยา อาหาร และการออกกำลังกาย'"
          :readonly="status == 'see'">
          <template v-slot:label>
            <span class="pr-3 text-333333 w-500 font-16">ความรู้คำปรึกษา เรื่องโรค การใช้ยา อาหาร
              และการออกกำลังกาย</span>
          </template>
        </v-checkbox>

        <v-row v-if="family_detail.family_problem.patient_need_for_help.knowledge_of_disease_counseling.status == '1'"
          no-gutters>
          <span class="pr-3 w-500 font-16 text-333333 pt-2">ระบุ</span>
          <v-text-field dense solo hide-details="auto"
            placeholder="กรุณาระบุความรู้คำปรึกษา เรื่องโรค การใช้ยา อาหาร และการออกกำลังกาย" color="#00A99D"
            v-model="family_detail.family_problem.patient_need_for_help.knowledge_of_disease_counseling.detail"
            :rules="status == 'see' ? [] : rules_detail" :readonly="status == 'see'"></v-text-field>
        </v-row>
      </v-row>
      <v-row class="pb-0 pt-2 pl-16 pr-3">
        <v-checkbox hide-details="auto" dense
          v-model="family_detail.family_problem.patient_need_for_help.support_for_specified_reclamation_tools.status"
          color="#00A99D" value="1"
          @click="family_detail.family_problem.patient_need_for_help.support_for_specified_reclamation_tools.title = 'สนับสนุน เครื่องมือ ฟื้นฟูสมรรถภาพ'"
          :readonly="status == 'see'">
          <template v-slot:label>
            <span class="pr-3 text-333333 w-500 font-16">สนับสนุน เครื่องมือ ฟื้นฟูสมรรถภาพ</span>
          </template>
        </v-checkbox>

        <v-row no-gutters
          v-if="family_detail.family_problem.patient_need_for_help.support_for_specified_reclamation_tools.status == '1'">
          <span class="pr-3 w-500 font-16 text-333333 pt-2">ระบุ</span>
          <v-text-field dense solo hide-details="auto" placeholder="กรุณาระบุเครื่องมือ ฟื้นฟูสมรรถภาพ" color="#00A99D"
            v-model="family_detail.family_problem.patient_need_for_help.support_for_specified_reclamation_tools.detail"
            :rules="status == 'see' ? [] : rules_detail" :readonly="status == 'see'"></v-text-field>
        </v-row>
      </v-row>
      <v-row class="pb-0 pt-2 pl-16 pr-3">
        <v-checkbox hide-details="auto" dense
          v-model="family_detail.family_problem.patient_need_for_help.supporting_the_economy.status" color="#00A99D"
          value="1"
          @click="family_detail.family_problem.patient_need_for_help.supporting_the_economy.title = 'สนับสนุนด้านเศรษฐกิจ ฟื้นฟูอาชีพ'"
          :readonly="status == 'see'">
          <template v-slot:label>
            <span class="pr-3 text-333333 w-500 font-16">สนับสนุนด้านเศรษฐกิจ ฟื้นฟูอาชีพ</span>
          </template>
        </v-checkbox>
        <v-row no-gutters
          v-if="family_detail.family_problem.patient_need_for_help.supporting_the_economy.status == '1'">
          <span class="pr-3 w-500 font-16 text-333333 pt-2">ระบุ</span>
          <v-text-field dense solo hide-details="auto" placeholder="กรูณาระบุด้านเศรษฐกิจ ฟื้นฟูอาชีพ" color="#00A99D"
            v-model="family_detail.family_problem.patient_need_for_help.supporting_the_economy.detail"
            :rules="status == 'see' ? [] : rules_detail" :readonly="status == 'see'"></v-text-field>
        </v-row>
      </v-row>
      <v-row class="pb-0 pt-2 pl-16 pr-3">
        <v-checkbox hide-details="auto" dense
          v-model="family_detail.family_problem.patient_need_for_help.other_detail.status" color="#00A99D" value="1"
          @click="family_detail.family_problem.patient_need_for_help.other_detail.title = 'อื่นๆ'"
          :readonly="status == 'see'">
          <template v-slot:label>
            <span class="pr-3 text-333333 w-500 font-16">อื่น ๆ</span>
          </template>
        </v-checkbox>
        <v-row no-gutters v-if="family_detail.family_problem.patient_need_for_help.other_detail.status == '1'">
          <span class="pr-3 w-500 font-16 text-333333 pt-2">ระบุ</span>
          <v-text-field dense solo hide-details="auto" placeholder="กรุณาระบุอื่น ๆ" color="#00A99D"
            v-model="family_detail.family_problem.patient_need_for_help.other_detail.detail"
            :rules="status == 'see' ? [] : rules_detail" :readonly="status == 'see'"></v-text-field>
        </v-row>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import html2canvas from 'html2canvas'
import StadiaMap from "@/components/stadiamap/StadiaMap.vue";

export default {
  props: ['status'],
  components: { StadiaMap },
  data() {
    return {
      dialog: false,
      edit: false,
      nav: null,
      url: null,
      image: null,
      data: {
        lat: 0,
        lng: 0,
      },
      location_address: '',
      latitude: 0,
      longitude: 0,
      lat: 0,
      lng: 0,
      isWrite: false,
      symbol_list: [
        { id: 1, symbol: 'บ้าน', img: require('@/assets/icon/visit/home.svg') },
        { id: 2, symbol: 'แม่น้ำ', img: require('@/assets/icon/visit/river.svg') },
        { id: 3, symbol: 'สถานประกอบการ', img: require('@/assets/icon/visit/factory.svg') },
        { id: 4, symbol: 'วัด', img: require('@/assets/icon/visit/wat-phra-kaew.svg') },
        { id: 5, symbol: 'สระน้ำ', img: require('@/assets/icon/visit/swimming-pool.svg') },
        { id: 6, symbol: 'โรงเรียน', img: require('@/assets/icon/visit/school.svg') },
        { id: 7, symbol: 'สถานีอนามัยศูนย์บริการสาธารณสุข', img: require('@/assets/icon/visit/medical-symbol.svg') },
        { id: 8, symbol: 'มัสยิด', img: require('@/assets/icon/visit/mosque.svg') },
        { id: 9, symbol: 'คลินิก', img: require('@/assets/icon/visit/pharmacy.svg') },
        { id: 10, symbol: 'โรงพยาบาล', img: require('@/assets/icon/visit/hospital-building.svg') },
        { id: 11, symbol: 'ศูนย์สุขภาพชุมชน', img: require('@/assets/icon/visit/clinic.svg') },
        { id: 12, symbol: '', img: '' }
      ],
      map_detail: {
        lat: '',
        lng: '',
        map_image: '',
        file_id_map_location: '',
        area_of_responsibility: ''
      },
      family_detail: {
        family_member: 1,
        family_list: [
          {
            name: "",
            age: "",
            occupation: "",
            right_of_treatment: "",
            detected_characteristics: ""
          }
        ],
        family_image: '',
        family_problem: {
          family_problems_and_perspectives_on_servants: { // ปัญหาในครอบครัวและมุมมองต่อผู้รับบริการ
            status: '',
            detail: "",
            title: ""
          },
          servant_perception_of_Family_problems: { // การรับรู้ของผู้รับบริการต่อปัญหาในครอบครัว
            detail: "",
          },
          patient_need_for_help: { //ความต้องการช่วยเหลือของผู้ป่วย
            knowledge_of_disease_counseling: { //ความรู้คำปรึกษา
              status: '0',
              detail: "",
              title: "ความรู้คำปรึกษา เรื่องโรค การใช้ยา อาหาร และการออกกำลังกาย"
            },
            support_for_specified_reclamation_tools: { //สนับสนุน เครื่องมือ ฟื้นฟูสมรรถภาพ
              status: '0',
              detail: "",
              title: "สนับสนุน เครื่องมือ ฟื้นฟูสมรรถภาพ"
            },
            supporting_the_economy: { //สนับสนุนด้านเศรษฐกิจ
              status: '0',
              detail: "",
              title: "สนับสนุนด้านเศรษฐกิจ ฟื้นฟูอาชีพ"
            },
            other_detail: { //อื่นๆ
              status: '0',
              detail: "",
              title: "อื่น ๆ"
            }
          }
        },
        file_id_family_image: '',
      },
      rules_checkbox: [(v) => !!v || "กรุณาเลือกข้อมูล"],
      rules_detail: [
        (v) => !!v || "กรุณาระบุข้อมูล",
        (v) => !/^\s+|\s+$/.test(v) || "กรุณาอย่าเว้นวรรคหน้าหรือหลังข้อความ",
        (v) => !/\s{2,}/.test(v) || "กรุณาเว้นวรรคระหว่างคำเพียง 1 ครั้ง",
      ],
      rules_detail_number: [
        (v) => !!v || "กรุณาระบุข้อมูล",
        (v) => /^-?\d+(\.\d+)?$/.test(v) || "กรอกได้เฉพาะตัวเลข",
        (v) => /^\S+$/.test(v) || "ห้ามกรอกช่องว่าง", //ห้ามกรอกช่องว่าง
      ],
      rules_space_bar: [
        (v) => !/^\s+|\s+$/.test(v) || "กรุณาอย่าเว้นวรรคหน้าหรือหลังข้อความ",
        (v) => !/\s{2,}/.test(v) || "กรุณาเว้นวรรคระหว่างคำเพียง 1 ครั้ง",
      ],
      rules_member: [
        (v) => !!v || "กรุณาระบุข้อมูล",
        (v) => v > 0 || 'กรุณาระบุข้อมูลที่มากกว่า 0'
      ],
      map_image_HTML: "",
      family_image_HTML: "",
    }
  },
  computed: {
    display_vuetify() {
      return this.$vuetify.breakpoint.name
    },
    phone() {
      if (this.$vuetify.breakpoint.width <= 450) {
        return true;
      } else {
        return false;
      }
    },
    tablet() {
      if (this.$vuetify.breakpoint.width <= 820) {
        return true;
      } else {
        return false;
      }
    },
    more_tablet() {
      if (this.$vuetify.breakpoint.width <= 1200) {
        return true;
      } else {
        return false;
      }
    }
  },
  async created() {
    // await this.checkGPS();
  },
  methods: {
    async openPage(map_detail, family_detail) {
      // console.log('map_detail page map', map_detail);
      // console.log('family_detail page map', family_detail);

      this.map_detail = {
        lat: 'lat' in map_detail && map_detail.lat !== '' && map_detail.lat !== null && map_detail.lat !== undefined ? parseFloat(map_detail.lat) : 0,
        lng: 'lng' in map_detail && map_detail.lng !== '' && map_detail.lng !== null && map_detail.lng !== undefined ? parseFloat(map_detail.lng) : 0,
        map_image: 'map_image' in map_detail && map_detail.map_image !== '' && map_detail.map_image !== null && map_detail.map_image !== undefined ? map_detail.map_image : '',
        file_id_map_location: 'file_id_map_location' in map_detail && map_detail.file_id_map_location !== '' && map_detail.file_id_map_location !== null && map_detail.file_id_map_location !== undefined ? map_detail.file_id_map_location : '',
        area_of_responsibility: 'area_of_responsibility' && map_detail.area_of_responsibility !== null && map_detail.area_of_responsibility !== undefined ? map_detail.area_of_responsibility : '',
      }

      this.latitude = 'lat' in map_detail && map_detail.lat !== '' && map_detail.lat !== null && map_detail.lat !== undefined ? parseFloat(map_detail.lat) : 0
      this.longitude = 'lng' in map_detail && map_detail.lng !== '' && map_detail.lng !== null && map_detail.lng !== undefined ? parseFloat(map_detail.lng) : 0,
        this.lat = 'lat' in map_detail && map_detail.lat !== '' && map_detail.lat !== null && map_detail.lat !== undefined ? parseFloat(map_detail.lat) : 0
      this.lng = 'lng' in map_detail && map_detail.lng !== '' && map_detail.lng !== null && map_detail.lng !== undefined ? parseFloat(map_detail.lng) : 0,

        this.family_detail = {
          family_member: 'family_member' in family_detail && family_detail.family_member !== '' && family_detail.family_member !== null && family_detail.family_member !== undefined && family_detail.family_member !== 0 ? family_detail.family_member : 1,
          family_list: 'family_list' in family_detail && family_detail.family_list.length !== 0 && family_detail.family_list.length !== null && family_detail.family_list.length !== undefined ? family_detail.family_list : [{ name: "", age: "", occupation: "", right_of_treatment: "", detected_characteristics: "" }],
          family_image: 'family_image' in family_detail && family_detail.family_image !== '' && family_detail.family_image !== null && family_detail.family_image !== undefined ? family_detail.family_image : '',
          family_problem: {
            family_problems_and_perspectives_on_servants: { // ปัญหาในครอบครัวและมุมมองต่อผู้รับบริการ
              status: 'family_problem' in family_detail && 'family_problems_and_perspectives_on_servants' in family_detail.family_problem && 'status' in family_detail.family_problem.family_problems_and_perspectives_on_servants && family_detail.family_problem.family_problems_and_perspectives_on_servants.status !== '' && family_detail.family_problem.family_problems_and_perspectives_on_servants.status !== null && family_detail.family_problem.family_problems_and_perspectives_on_servants.status !== undefined ? family_detail.family_problem.family_problems_and_perspectives_on_servants.status : '',
              detail: 'family_problem' in family_detail && 'family_problems_and_perspectives_on_servants' in family_detail.family_problem && 'detail' in family_detail.family_problem.family_problems_and_perspectives_on_servants && family_detail.family_problem.family_problems_and_perspectives_on_servants.detail !== '' && family_detail.family_problem.family_problems_and_perspectives_on_servants.detail !== null && family_detail.family_problem.family_problems_and_perspectives_on_servants.detail !== undefined ? family_detail.family_problem.family_problems_and_perspectives_on_servants.detail : '',
              title: 'family_problem' in family_detail && 'family_problems_and_perspectives_on_servants' in family_detail.family_problem && 'title' in family_detail.family_problem.family_problems_and_perspectives_on_servants && family_detail.family_problem.family_problems_and_perspectives_on_servants.title !== '' && family_detail.family_problem.family_problems_and_perspectives_on_servants.title !== null && family_detail.family_problem.family_problems_and_perspectives_on_servants.title !== undefined ? family_detail.family_problem.family_problems_and_perspectives_on_servants.title : '',
            },
            servant_perception_of_Family_problems: { // การรับรู้ของผู้รับบริการต่อปัญหาในครอบครัว
              detail: 'family_problem' in family_detail && 'servant_perception_of_Family_problems' in family_detail.family_problem && 'detail' in family_detail.family_problem.servant_perception_of_Family_problems && family_detail.family_problem.servant_perception_of_Family_problems.detail !== '' && family_detail.family_problem.servant_perception_of_Family_problems.detail !== null && family_detail.family_problem.servant_perception_of_Family_problems.detail !== undefined ? family_detail.family_problem.servant_perception_of_Family_problems.detail : '',
            },
            patient_need_for_help: { //ความต้องการช่วยเหลือของผู้ป่วย
              knowledge_of_disease_counseling: { //ความรู้คำปรึกษา
                status: 'family_problem' in family_detail && 'patient_need_for_help' in family_detail.family_problem && 'knowledge_of_disease_counseling' in family_detail.family_problem.patient_need_for_help && 'status' in family_detail.family_problem.patient_need_for_help.knowledge_of_disease_counseling && family_detail.family_problem.patient_need_for_help.knowledge_of_disease_counseling.status !== '' && family_detail.family_problem.patient_need_for_help.knowledge_of_disease_counseling.status !== null && family_detail.family_problem.patient_need_for_help.knowledge_of_disease_counseling.status !== undefined ? family_detail.family_problem.patient_need_for_help.knowledge_of_disease_counseling.status : '',
                detail: 'family_problem' in family_detail && 'patient_need_for_help' in family_detail.family_problem && 'knowledge_of_disease_counseling' in family_detail.family_problem.patient_need_for_help && 'detail' in family_detail.family_problem.patient_need_for_help.knowledge_of_disease_counseling && family_detail.family_problem.patient_need_for_help.knowledge_of_disease_counseling.detail !== '' && family_detail.family_problem.patient_need_for_help.knowledge_of_disease_counseling.detail !== null && family_detail.family_problem.patient_need_for_help.knowledge_of_disease_counseling.detail !== undefined ? family_detail.family_problem.patient_need_for_help.knowledge_of_disease_counseling.detail : '',
                title: 'family_problem' in family_detail && 'patient_need_for_help' in family_detail.family_problem && 'knowledge_of_disease_counseling' in family_detail.family_problem.patient_need_for_help && 'title' in family_detail.family_problem.patient_need_for_help.knowledge_of_disease_counseling && family_detail.family_problem.patient_need_for_help.knowledge_of_disease_counseling.title !== '' && family_detail.family_problem.patient_need_for_help.knowledge_of_disease_counseling.title !== null && family_detail.family_problem.patient_need_for_help.knowledge_of_disease_counseling.title !== undefined ? family_detail.family_problem.patient_need_for_help.knowledge_of_disease_counseling.title : '',
              },
              support_for_specified_reclamation_tools: { //สนับสนุน เครื่องมือ ฟื้นฟูสมรรถภาพ
                status: 'family_problem' in family_detail && 'patient_need_for_help' in family_detail.family_problem && 'support_for_specified_reclamation_tools' in family_detail.family_problem.patient_need_for_help && 'status' in family_detail.family_problem.patient_need_for_help.support_for_specified_reclamation_tools && family_detail.family_problem.patient_need_for_help.support_for_specified_reclamation_tools.status !== '' && family_detail.family_problem.patient_need_for_help.support_for_specified_reclamation_tools.status !== null && family_detail.family_problem.patient_need_for_help.support_for_specified_reclamation_tools.status !== undefined ? family_detail.family_problem.patient_need_for_help.support_for_specified_reclamation_tools.status : '',
                detail: 'family_problem' in family_detail && 'patient_need_for_help' in family_detail.family_problem && 'support_for_specified_reclamation_tools' in family_detail.family_problem.patient_need_for_help && 'detail' in family_detail.family_problem.patient_need_for_help.support_for_specified_reclamation_tools && family_detail.family_problem.patient_need_for_help.support_for_specified_reclamation_tools.detail !== '' && family_detail.family_problem.patient_need_for_help.support_for_specified_reclamation_tools.detail !== null && family_detail.family_problem.patient_need_for_help.support_for_specified_reclamation_tools.detail !== undefined ? family_detail.family_problem.patient_need_for_help.support_for_specified_reclamation_tools.detail : '',
                title: 'family_problem' in family_detail && 'patient_need_for_help' in family_detail.family_problem && 'support_for_specified_reclamation_tools' in family_detail.family_problem.patient_need_for_help && 'title' in family_detail.family_problem.patient_need_for_help.support_for_specified_reclamation_tools && family_detail.family_problem.patient_need_for_help.support_for_specified_reclamation_tools.title !== '' && family_detail.family_problem.patient_need_for_help.support_for_specified_reclamation_tools.title !== null && family_detail.family_problem.patient_need_for_help.support_for_specified_reclamation_tools.title !== undefined ? family_detail.family_problem.patient_need_for_help.support_for_specified_reclamation_tools.title : '',
              },
              supporting_the_economy: { //สนับสนุนด้านเศรษฐกิจ
                status: 'family_problem' in family_detail && 'patient_need_for_help' in family_detail.family_problem && 'supporting_the_economy' in family_detail.family_problem.patient_need_for_help && 'status' in family_detail.family_problem.patient_need_for_help.supporting_the_economy && family_detail.family_problem.patient_need_for_help.supporting_the_economy.status !== '' && family_detail.family_problem.patient_need_for_help.supporting_the_economy.status !== null && family_detail.family_problem.patient_need_for_help.supporting_the_economy.status !== undefined ? family_detail.family_problem.patient_need_for_help.supporting_the_economy.status : '',
                detail: 'family_problem' in family_detail && 'patient_need_for_help' in family_detail.family_problem && 'supporting_the_economy' in family_detail.family_problem.patient_need_for_help && 'detail' in family_detail.family_problem.patient_need_for_help.supporting_the_economy && family_detail.family_problem.patient_need_for_help.supporting_the_economy.detail !== '' && family_detail.family_problem.patient_need_for_help.supporting_the_economy.detail !== null && family_detail.family_problem.patient_need_for_help.supporting_the_economy.detail !== undefined ? family_detail.family_problem.patient_need_for_help.supporting_the_economy.detail : '',
                title: 'family_problem' in family_detail && 'patient_need_for_help' in family_detail.family_problem && 'supporting_the_economy' in family_detail.family_problem.patient_need_for_help && 'title' in family_detail.family_problem.patient_need_for_help.supporting_the_economy && family_detail.family_problem.patient_need_for_help.supporting_the_economy.title !== '' && family_detail.family_problem.patient_need_for_help.supporting_the_economy.title !== null && family_detail.family_problem.patient_need_for_help.supporting_the_economy.title !== undefined ? family_detail.family_problem.patient_need_for_help.supporting_the_economy.title : '',
              },
              other_detail: { //อื่นๆ
                status: 'family_problem' in family_detail && 'patient_need_for_help' in family_detail.family_problem && 'other_detail' in family_detail.family_problem.patient_need_for_help && 'status' in family_detail.family_problem.patient_need_for_help.other_detail && family_detail.family_problem.patient_need_for_help.other_detail.status !== '' && family_detail.family_problem.patient_need_for_help.other_detail.status !== null && family_detail.family_problem.patient_need_for_help.other_detail.status !== undefined ? family_detail.family_problem.patient_need_for_help.other_detail.status : '',
                detail: 'family_problem' in family_detail && 'patient_need_for_help' in family_detail.family_problem && 'other_detail' in family_detail.family_problem.patient_need_for_help && 'detail' in family_detail.family_problem.patient_need_for_help.other_detail && family_detail.family_problem.patient_need_for_help.other_detail.detail !== '' && family_detail.family_problem.patient_need_for_help.other_detail.detail !== null && family_detail.family_problem.patient_need_for_help.other_detail.detail !== undefined ? family_detail.family_problem.patient_need_for_help.other_detail.detail : '',
                title: 'family_problem' in family_detail && 'patient_need_for_help' in family_detail.family_problem && 'other_detail' in family_detail.family_problem.patient_need_for_help && 'title' in family_detail.family_problem.patient_need_for_help.other_detail && family_detail.family_problem.patient_need_for_help.other_detail.title !== '' && family_detail.family_problem.patient_need_for_help.other_detail.title !== null && family_detail.family_problem.patient_need_for_help.other_detail.title !== undefined ? family_detail.family_problem.patient_need_for_help.other_detail.title : '',
              }
            }
          },
          file_id_family_image: 'file_id_family_image' in family_detail && family_detail.file_id_family_image !== '' && family_detail.file_id_family_image !== null && family_detail.file_id_family_image !== undefined ? family_detail.file_id_family_image : ''
        }


      if ('file_id_family_image' in family_detail && family_detail.file_id_family_image !== '' && family_detail.file_id_family_image !== null && family_detail.file_id_family_image !== undefined) {
        await this.get_img_onebox(family_detail.file_id_family_image, 'family')

        if (this.family_image_HTML !== '') {
          this.family_detail.family_image = this.family_image_HTML
        }
      } else {
        if ('family_image' in family_detail && family_detail.family_image !== '' && family_detail.family_image !== null && family_detail.family_image !== undefined) {
          this.family_detail.family_image = family_detail.family_image
          this.edit = false
        } else {
          this.family_detail.family_image = ''
          this.edit = true
        }
      }

      if ('file_id_map_location' in map_detail && map_detail.file_id_map_location !== '' && map_detail.file_id_map_location !== null && map_detail.file_id_map_location !== undefined) {
        await this.get_img_onebox(map_detail.file_id_map_location, 'map')

        if (this.map_image_HTML !== '') {
          this.map_detail.map_image = this.map_image_HTML
        }
      } else {
        if ('map_image' in map_detail && map_detail.map_image !== '' && map_detail.map_image !== null && map_detail.map_image !== undefined) {
          this.map_detail.map_image = map_detail.map_image
        } else {
          this.map_detail.map_image = ''
        }
      }

      this.$refs.form1.resetValidation()
    },
    async get_img_onebox(item, text) {
      try {
        const params = new URLSearchParams();
        params.append("file_id", item);

        await this.axios.get(`${process.env.VUE_APP_BACKEND_URL}/v1/download_home_visit_one_box?${params}`).then((res) => {
          console.log('onebox', res);
          if (res.data.result == 'success' && res.data.code == 200) {
            if (res.data.data !== '' && res.data.data !== null && res.data.data !== undefined) {
              if (text == 'family') {
                this.family_image_HTML = 'data:image/png;base64,' + res.data.data
                this.edit = false
              } else if (text == 'map') {
                this.map_image_HTML = 'data:image/png;base64,' + res.data.data
              }
            } else {
              if (text == 'family') {
                this.family_image_HTML = ''
                this.edit = true
              } else if (text == 'map') {
                this.map_image_HTML = ''
              }
            }
          }
        })
      } catch (err) {
        console.log(err);
      }
    },
    async get_img() {
      try {
        var target = await this.$refs.printcontent;
        var img = ''

        var element = document.getElementById('capture');
        var positionInfo = element.getBoundingClientRect();
        var height = positionInfo.height;
        var width = positionInfo.width;

        if (this.phone == true && this.tablet == true && this.more_tablet == true) {
          await html2canvas(target, {
            useCORS: true,
            imageTimeout: 3000,
          }).then(async function (canvas) {
            img = await canvas.toDataURL("image/png");
          })
        } else if (this.phone == false && this.tablet == true && this.more_tablet == true) {
          await html2canvas(target, {
            useCORS: true,
            imageTimeout: 8000,
          }).then(async function (canvas) {
            var tempcanvas = document.createElement('canvas');
            tempcanvas.width = width
            tempcanvas.height = height
            var context = tempcanvas.getContext('2d');
            context.drawImage(canvas, 0, 0, width, height);
            img = tempcanvas.toDataURL('image/png')
          })
        } else if (this.phone == false && this.tablet == false && this.more_tablet == true) {
          await html2canvas(target, {
            useCORS: true,
            imageTimeout: 8000,
          }).then(async function (canvas) {
            var tempcanvas3 = document.createElement('canvas');
            tempcanvas3.width = width
            tempcanvas3.height = height - 220
            var context3 = tempcanvas3.getContext('2d');
            context3.drawImage(canvas, 15, 0, width + 600, height + 1180, 0, 0, width, height + 200);
            img = tempcanvas3.toDataURL('image/png')
          })
        } else if (this.phone == false && this.tablet == false && this.more_tablet == false) {
          await html2canvas(target, {
            useCORS: true,
            imageTimeout: 3000,
          }).then(async function (canvas) {
            var tempcanvas2 = document.createElement('canvas');
            tempcanvas2.width = width
            tempcanvas2.height = height
            var context2 = tempcanvas2.getContext('2d');
            context2.drawImage(canvas, 0, 0, width, height);
            img = tempcanvas2.toDataURL('image/png')
          })
        }
        // console.log('img', img);
        if (img !== '' && img !== null && img !== undefined && img !== "data:,") {
          this.map_detail.map_image = img
        }
      } catch (err) {
        console.log(err);
      }
    },
    async valid1(status) {
      await this.get_img()
      if ((this.edit == false || this.edit == true) && this.family_detail.family_image == '') {
        if (this.$refs.signaturePad.saveSignature().data !== undefined && this.$refs.signaturePad.saveSignature().data !== null && this.$refs.signaturePad.saveSignature().data !== '') {
          const { data } = this.$refs.signaturePad.saveSignature()
          this.family_detail.family_image = data
        } else {
          this.family_detail.family_image = ''
        }
      } else if (this.edit == true && this.family_detail.family_image !== '') {
        if (this.$refs.signaturePad.saveSignature().data !== undefined && this.$refs.signaturePad.saveSignature().data !== null && this.$refs.signaturePad.saveSignature().data !== '') {
          const { data } = this.$refs.signaturePad.saveSignature()
          this.family_detail.family_image = data
        } else {
          this.family_detail.family_image = ''
        }
      }

      // family_problems_and_perspectives_on_servants
      if (this.family_detail.family_problem.family_problems_and_perspectives_on_servants.status == null || this.family_detail.family_problem.family_problems_and_perspectives_on_servants.status == '') {
        this.family_detail.family_problem.family_problems_and_perspectives_on_servants = {
          status: '',
          detail: "",
          title: ""
        }
      }

      // patient_need_for_help.knowledge_of_disease_counseling
      if (this.family_detail.family_problem.patient_need_for_help.knowledge_of_disease_counseling.status == null || this.family_detail.family_problem.patient_need_for_help.knowledge_of_disease_counseling.status == '') {
        this.family_detail.family_problem.patient_need_for_help.knowledge_of_disease_counseling = {
          status: '0',
          detail: "",
          title: "ความรู้คำปรึกษา เรื่องโรค การใช้ยา อาหาร และการออกกำลังกาย"
        }
      }

      // patient_need_for_help.support_for_specified_reclamation_tools
      if (this.family_detail.family_problem.patient_need_for_help.support_for_specified_reclamation_tools.status == null || this.family_detail.family_problem.patient_need_for_help.support_for_specified_reclamation_tools.status == '') {
        this.family_detail.family_problem.patient_need_for_help.support_for_specified_reclamation_tools = {
          status: '0',
          detail: "",
          title: "สนับสนุน เครื่องมือ ฟื้นฟูสมรรถภาพ"
        }
      }

      // patient_need_for_help.supporting_the_economy
      if (this.family_detail.family_problem.patient_need_for_help.supporting_the_economy.status == null || this.family_detail.family_problem.patient_need_for_help.supporting_the_economy.status == '') {
        this.family_detail.family_problem.patient_need_for_help.supporting_the_economy = {
          status: '0',
          detail: "",
          title: "สนับสนุนด้านเศรษฐกิจ ฟื้นฟูอาชีพ"
        }
      }

      // patient_need_for_help.other_detail
      if (this.family_detail.family_problem.patient_need_for_help.other_detail.status == null || this.family_detail.family_problem.patient_need_for_help.other_detail.status == '') {
        this.family_detail.family_problem.patient_need_for_help.other_detail = {
          status: '0',
          detail: "",
          title: "อื่น ๆ"
        }
      }

      var check_family_list = []

      if (this.family_detail.family_list !== 0) {

        this.family_detail.family_list.forEach(ele => {
          if (ele.name !== '') {
            check_family_list.push(ele)
          }
        });
      }

      var data1 = {
        map_detail: this.map_detail,
        family_member: check_family_list.length || 0,
        family_list: check_family_list || [],
        family_image: this.family_detail.family_image,
        family_problem: this.family_detail.family_problem,
      }
      this.$emit('data1', data1)
      if (status == 'finish') {
        if (this.$refs.form1.validate()) {
          this.$emit('valid1', false)
        } else {
          this.$emit('valid1', true)
        }
      } else if (status == '1page') {
        if (this.$refs.form1.validate()) {
          this.$emit('valid1', false)
        } else {
          this.$emit('valid1', true)
        }
      }
    },
    onEnd() {
      // console.log('his.$refs.signaturePad.saveSignature()',this.$refs.signaturePad.saveSignature());
      const { isEmpty } = this.$refs.signaturePad.saveSignature();
      if (isEmpty === true) {
        this.isWrite = false;
      } else {
        this.isWrite = true;
      }
    },
    clearSign() {
      this.$refs.signaturePad.clearSignature();
      this.isWrite = false;
    },
    clearBack() {
      const { isEmpty } = this.$refs.signaturePad.saveSignature();
      if (isEmpty === true) {
        this.isWrite = false;
      } else {
        this.$refs.signaturePad.undoSignature();
      }
    },
    checkMember(num) {
      if (num == 0) {
        this.family_detail.family_member = this.family_detail.family_list.length
      } else if (this.family_detail.family_list.length !== num) {

        if (this.family_detail.family_list.length < num) {
          var n = num - this.family_detail.family_list.length

          for (let index = 0; index < n; index++) {
            this.family_detail.family_list.push({ name: '', age: '', occupation: '', detected_characteristics: '' });
          }
        } else if (this.family_detail.family_list.length > num) {
          var f = this.family_detail.family_list.length - num

          for (let index = 0; index < f; index++) {
            this.family_detail.family_list.splice((this.family_detail.family_list.length - 1), 1);
          }
        }
      }
    },
    async aad_family() {
      if (this.status !== 'see') {
        await this.family_detail.family_list.push(
          { name: '', age: '', occupation: '', detected_characteristics: '' }
        );
        this.family_detail.family_member = this.family_detail.family_list.length
      }

    },
    delete_family(index) {
      if (this.status !== 'see') {
        if (this.family_detail.family_list.length === 1) {
          this.family_detail.family_list = [
            {
              name: "",
              age: "",
              occupation: "",
              right_of_treatment: "",
              detected_characteristics: ''
            }
          ]
        } else {
          this.family_detail.family_list.splice(index, 1);
        }
        this.family_detail.family_member = this.family_detail.family_list.length
      }
    },
    getGPS() {
      this.location_address = "";
    },
    async checkGPS() {
      this.$refs.locateUser.getCurrentLocation();
      this.location_address = "";
      // await navigator.geolocation.getCurrentPosition(
      //   (position) => {
      //     const { coords: { latitude: lat, longitude: lng } = {} } = position;
      //     this.latitude = lat;
      //     this.longitude = lng;
      //     this.map_detail.lat = lat;
      //     this.map_detail.lng = lng;
      //     this.lat = lat;
      //     this.lng = lng;
      //   },
      //   (error) => {
      //     console.log(error);
      //   }
      // );
    },
    changeLocation(e) {
      // console.log("🚀 ~ changeLocation ~ e:", e)
      this.map_detail.lat = e.lat;
      this.map_detail.lng = e.lng;
      this.lat = e.lat;
      this.lng = e.lng;
      this.location_address = "";
    },
    async getLocation(address) {
      console.log("🚀 ~ address:", address)
      try {
        // const params = new URLSearchParams();
        // params.append("address", address);

        // await this.axios.get(`${process.env.VUE_APP_BACKEND_URL}/v1/pharma/get-location?${params}`).then((res) => {
        //   // console.log("res", res);
        //   if (res.data.result == "success" && res.data.code == 200) {
        //     var data = res.data.data
        //     this.latitude = data.lat;
        //     this.longitude = data.lng;
        //     this.map_detail.lat = data.lat;
        //     this.map_detail.lng = data.lng;
        //     this.lat = data.lat;
        //     this.lng = data.lng;
        //   }
        // });
        const url = `https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(address)}&format=json`;
        fetch(url)
          .then((response) => response.json())
          .then((data) => {
            console.log("🚀 ~ data:", data)
            if (data.length > 0) {
              const { lat, lon } = data[0]; // ดึงค่า lat และ lon จากผลลัพธ์ตัวแรก
              console.log("Latitude:", lat);
              console.log("Longitude:", lon);
              this.map_detail.lat = lat;
              this.map_detail.lng = lon;
              this.lat = lat;
              this.lng = lon;
            } else {
              console.log("ไม่พบข้อมูลที่อยู่");
            }
          });
      } catch (error) {
        console.error();
      }
    },
    validateNumber: (event) => {
      const keyCode = event.keyCode;
      if (keyCode < 46 || keyCode > 57 || keyCode == 47) {
        event.preventDefault();
      }
    }
  },
}
</script>

<style scoped>
.text_name {
  text-align: end;
  padding-bottom: 0px;
  padding-left: 10px;
  justify-self: center;
  align-self: center;
}

.text_Body {
  align-self: center;
  padding-top: 0px;
  padding-bottom: 0px;
  justify-content: center;
}

.text_body {
  align-self: center;
  padding-bottom: 0px;
  justify-content: center;
}

::v-deep .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)>.v-input__control>.v-input__slot {
  border: 1px solid #e8e9e9;
  box-sizing: border-box;
  border-radius: 6px;
  box-shadow: none;
}

::v-deep .theme--light.v-text-field>.v-input__control>.v-input__slot:before {
  border-color: #00A99D !important;
}

::v-deep .v-input--selection-controls__input+.v-label {
  font-size: 16px !important;
  color: #333333 !important;
}

::v-deep .v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)>.v-input__control>.v-input__slot {
  border: 1px solid #e8e9e9;
  box-sizing: border-box;
  border-radius: 6px;
  box-shadow: none;
}

::v-deep .theme--light.v-input--is-disabled input,
.theme--light.v-input--is-disabled textarea {
  color: #333333;
}

::v-deep .v-input--is-disabled>.v-input__control>.v-input__slot {
  background: #e8e9e9 !important;
}

::v-deep .v-toolbar__content {
  justify-content: center;
}

.text-red {
  color: red;
}

.container {
  max-width: 100%;
  max-height: 700px;
}

.v-dialog>.v-card>.v-card__text {
  padding: 0px;
}

.map {
  border-radius: 15px !important;
  height: 50vh;
  width: 100%;
}

#map {
  border-radius: 15px !important;
  height: 50vh;
  width: 100%;
}

::v-deep .v-dialog {
  background-color: white !important;
}

::v-deep .v-text-field.v-text-field--solo.v-input--dense .v-input__append-outer {
  margin-top: 0px !important;
}

::v-deep .theme--light.v-select .v-select__selection--disabled {
  color: #333333 !important;
}

.gmap-auto {
  width: 100%;
  line-height: 35px;
  border: 1px solid #e8e9e9;
  border-radius: 5px;
  font-size: 14px;
}

.gmap-auto:focus {
  outline: none !important;
}

::v-deep .v-select__selections {
  line-height: 1.8rem;
}

::v-deep .v-text-field.v-text-field--solo .v-input__control input {
  line-height: 1.8rem;
}

::v-deep .v-input input {
  line-height: 1.8rem;
}

/* สำหรับ Chrome, Edge และเบราว์เซอร์ที่ใช้ WebKit */
::v-deep input[type="number"]::-webkit-inner-spin-button,
::v-deep input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* สำหรับ Firefox */
::v-deep input[type="number"] {
  -moz-appearance: textfield;
}
</style>